$(function() {
    $(".progressC").each(function() {

    var value = $(this).attr('data-value');
    var left = $(this).find('.progressC-left .progressC-bar');
    var right = $(this).find('.progressC-right .progressC-bar');

    if (value > 0) {
        if (value <= 50) {
        right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)')
        } else {
        right.css('transform', 'rotate(180deg)')
        left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)')
        }
    }

    })

    function percentageToDegrees(percentage) {

    return percentage / 100 * 360

    }

});

$('input').focus(function(){
    $(this).parents('.form-group').addClass('focused');
  });
  
  $('input').blur(function(){
    var inputValue = $(this).val();
    if ( inputValue == "" ) {
      $(this).removeClass('filled');
      $(this).parents('.form-group').removeClass('focused');  
    } else {
      $(this).addClass('filled');
    }
  })